<template>
    <div id="personalOrders">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">{{langText.myOrder}}</div>
        </nav-bar>
        <div style="width: 94%; margin: auto;">
            <van-tabs v-model="active" animated swipeable >
                <van-tab v-for="index in [ langText.all, langText.obligation, langText.sendGoods, langText.shipped, langText.completed, langText.canceled]" :title="index">
                    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                        <van-list
                                v-model="loading"
                                :finished="finished"
                                :finished-text = "langText.noMore"
                                @load="onLoad"
                        >
                            <ul class="content">
                                <li ref="li" v-for="(item, orderIndex) of orderList" v-if="item">
                                    <div class="order-no" @click="toOrderDetail(item.orderSn,item.status,item.id)" style="border-top-right-radius: 10px; border-top-left-radius: 10px;">
                                        <span class="left-text">{{langText.orderNumber}}:{{item.orderSn}}</span>
                                        <span class="right-text" v-if="item.status == 0">{{langText.obligation}}</span>
                                        <span class="right-text" v-if="item.status == 1">{{langText.sendGoods}}</span>
                                        <span class="right-text" v-if="item.status == 2">{{langText.shipped}}</span>
                                        <span class="right-text" v-if="item.status == 3">{{langText.completed}}</span>
                                        <span class="right-text" v-if="item.status == 4">{{langText.closed}}</span>
                                        <span class="right-text" v-if="item.status == 5">{{langText.InvalidOrders}}</span>
                                    </div>
                                    <div class="order-list-goods">
                                        <van-card
                                                :num="goodsItem.productQuantity"
                                                :price="goodsItem.productPrice"
                                                :desc="getProductDesc(goodsItem.productAttr)"
                                                :title="goodsItem.productName"
                                                :thumb="goodsItem.productPic"
                                                v-for="(goodsItem, goodsIndex) of item.orderItemList"
                                                @click="buyAgain(goodsItem.productId)"/>
                                    </div>
                                    <div class="order-operation" v-if="item.status == 0">
                                        <span class="left-text">{{langText.immediatePayment}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <van-button plain size="small" class="right-button" type="danger" @click="toPayment(item.orderSn)">{{langText.amountPayable}}</van-button>
                                        <van-button plain size="small" class="left-button" @click="cancelOrder(item.id, orderIndex)">{{langText.cancellationOrder}}</van-button>
                                    </div>
                                    <div class="order-operation" v-if="item.status == 1">
                                        <span class="left-text">{{langText.amountPaid}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <!--                                    <van-button plain size="small" class="right-button" @click="confirmGoods(item.id, orderIndex)">确认收货</van-button>-->
                                        <!--                                    <van-button plain size="small" class="left-button" to="/order/logisticsOrder">查看物流</van-button>-->
                                    </div>
                                    <div class="order-operation" v-if="item.status == 2">
                                        <span class="left-text">{{langText.amountPaid}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <van-button plain size="small" class="right-button" @click="confirmGoods(item.id, orderIndex)">{{langText.confirmReceipt}}</van-button>
                                        <van-button plain size="small" class="left-button" @click="goLogisticsOrder(item.orderSn)">{{langText.logistics}}</van-button>
                                    </div>
                                    <div class="order-operation" v-if="item.status == 3">
                                        <span class="left-text">{{langText.amountPaid}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <!--                                    <van-button plain size="small" class="right-button" to="/goods/goodsInfo/">再次购买</van-button>-->
                                        <!--                                    <van-button plain size="small" class="left-button">评价商品</van-button>-->
                                    </div>
                                    <!--                                <div class="order-operation" v-if="item.status == 2 && item.comment_status == 1">-->
                                    <!--                                    <span class="left-text">已付金额:￥180.00</span>-->
                                    <!--                                    <van-button plain size="small" class="right-button">再次购买</van-button>-->
                                    <!--                                    <van-button plain size="small" class="left-button">查看评价</van-button>-->
                                    <!--                                </div>-->
                                    <div class="order-operation" v-if="item.status == 4" >
                                        <span class="left-text">{{langText.immediatePayment}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <van-button plain size="small" class="right-button" @click="deleteOrder(orderIndex, item.id)">{{langText.deleteOrder}}</van-button>
                                        <!--                                    <van-button plain size="small" class="left-button" to="/order/shoppingCart">重新购买</van-button>-->
                                    </div>

                                    <!--退款中的按钮-->
                                    <div class="order-operation" v-if="item.status == 5" >
                                        <span class="left-text">{{langText.immediatePayment}}:</span>
                                        <span class="left-text-price">￥{{item.payAmount}}</span>
                                        <van-button plain size="small" class="right-button" @click="gorefund()">{{langText.refund}}</van-button>
                                    </div>

                                </li>
                            </ul>
                        </van-list>
                        <div v-if="!orderList" style="height: 500px">
                        </div>
                    </van-pull-refresh>
                </van-tab>
            </van-tabs>
            <van-popup
                    v-model="showCancelOrder"
                    closeable
                    position="bottom"
            >
                <div class="cancel-order">
                    {{langText.cancellationOrder}}
                </div>
                <van-divider />
                <div class="selected-reason">
                 <!-- todo 删除原因 需要做成后台设定 -->
                    <p style="font-size: 15px;">
                        取消订单后，本单享有的优惠可能会一并取消，是否继续？
                    </p>
                    <p style="color: #666666">请选择取消订单的原因（必选）：</p>
                    <van-checkbox-group v-model="result">
                        <van-checkbox name="a">配送信息有误</van-checkbox>
                        <van-checkbox name="b">发票信息有误</van-checkbox>
                        <van-checkbox name="c">忘记使用优惠券、积分等</van-checkbox>
                        <van-checkbox name="d">商品买错了</van-checkbox>
                        <van-checkbox name="e">重复下单/误下单</van-checkbox>
                    </van-checkbox-group>
                 <!--end-->
                </div>
                <div>
                    <van-divider />
                    <div class="cancel-order-button" @click="subCancelOrder">{{langText.bool}}</div>
                </div>
            </van-popup>
        </div>

    </div>
</template>

<script>
    import {Tabs, Tab, Icon, Card, Button, Toast, List, PullRefresh, Popup, Divider, CheckboxGroup, Checkbox, Dialog} from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    import Scroll from "@/components/common/scroll/Scroll";
    import {confirmGoods, getOrderByType, cancelOrder, deleteOrder} from "../../network/order/order";

    import { langPackage } from "@/config/lang/personalOrdersLang";
    import { selectLang } from "@/config/setLanguage";

    export default {
        name: "PersonalOrders",
        components: {
            NavBar: NavBar,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Icon.name]: Icon,
            [Card.name]: Card,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh,
            [Popup.name]: Popup,
            [Divider.name]: Divider,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
            [Dialog.name]: Dialog,
            Scroll: Scroll
        },
        data() {
            return {
                result: [],
                active: parseInt(this.$route.query.active),
                loading: false,
                finished: false,
                refreshing: true,
                showCancelOrder: false,
                orderList: [],
                pageNum: 0,
                pageSize: 10,
                status: parseInt(this.$route.query.active) -1,              //订单状态：-1->全部；0->待付款；1->待发货；2->已发货；3->已完成；4->已关闭,可用值:-1,0,1,2,3,4
                cancelOrderId: 0,
                cancelOrderKey: 0,
                langText:{},
                lang:"cn"
            }
        },
        methods: {
            goLogisticsOrder(order){
                this.$router.push({path: '/order/logisticsOrder', query: {'order': order}})
            },
            goBack() {
                this.$router.push('/mine');
            },
            buyAgain(product){
                this.$router.push('/goods/goodsInfo/'+product);
            },
            getProductDesc(productArr){
                let str = '';
                if(productArr == null){
                    return str
                }
                let arr = JSON.parse(productArr);
                for(let $i = 0; $i < arr.length; $i++) {
                    str += arr[$i]['key'] + ':' + arr[$i]['value']
                    if ($i != arr.length -1){
                        str += ' / ';
                    }
                }
                return str;
            },
            toOrderDetail(orderSn, status, id){
                this.$router.push({ path: '/order/orderDetail',
                    query: {id:id, status:status, orderSn: orderSn}})
            },
            onLoad() {
                this.pageNum++;
                getOrderByType({pageNum: this.pageNum, pageSize: this.pageSize, status: this.status}).then(res => {
                    // console.log(res);
                    if(this.refreshing) {
                        this.refreshing = false;
                        this.orderList = res.data.list;
                    }else{
                        if(this.orderList[0]){
                            this.orderList= this.orderList.concat(res.data.list)
                        }else {
                            this.orderList = res.data.list;
                        }
                    }
                    if(!res.data.list) {
                        this.finished = true
                    } else if(res.data.list.length < this.pageSize){
                        this.finished = true
                    }
                    this.loading = false;
                })
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.orderList = [];
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.pageNum = 0;
                this.onLoad();
            },
            cancelOrder(orderId, key) {
                this.cancelOrderId = orderId;
                this.cancelOrderKey = key;
                this.showCancelOrder = true;
            },
            //提交取消订单
            subCancelOrder() {
                cancelOrder(this.cancelOrderId).then( res => {
                    this.orderList.splice(this.cancelOrderKey, 1);
                }).catch( err => {
                    Toast(err)
                })
                this.showCancelOrder = false;
            },
            //确认收货
            confirmGoods (orderId, orderListKey) {
                Dialog.confirm({
                    title: '确认收货',
                    message: '是否确认收货？',
                    confirmButtonColor: '#6698cb'
                }).then(() => {
                    confirmGoods(orderId).then(res => {
                        let orderListItem = this.orderList[orderListKey];
                        orderListItem['status'] = 3;  //修改状态
                        this.$set(this.orderList, orderListKey, orderListItem)
                        Toast(res.message)
                    }).catch(
                        err => { Toast(err) }
                    )
                });
            },
            gorefund(){
                this.$router.push({path:'/order/afterSalesServiceList', query: {active: 1}});
            },
            //删除订单
            deleteOrder(index,orderId) {
                Dialog.confirm({
                    title: '确认删除',
                    message: '是否确认删除订单？'
                }).then(() => {
                    deleteOrder(orderId).then(res => {
                        Toast(res.message);
                        this.orderList.splice(index,1);
                    }).catch(err => {
                        Toast(err)
                    })
                });
            },
            toPayment(orderSn) {
                // console.log(orderSn);
                this.$router.push({path : '/order/waitingPayment' , query: {id:orderSn}})
            }
        },
        watch: {
            active: function (res) {
                this.active = res;
                this.status = res - 1;   //改变搜索的订单状态条件
                this.onRefresh()
            }
        },
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });


        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #personalOrders{
        width: 100%;
        height: 1000px;
        background: #f8f6f7;
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }

    .van-tabs {
        margin-top: 46px;
    }


    ::v-deep .van-tab__pane {
        height: 100%;
    }


    .order-no {
        height: 45px;
        background-color: #ffffff;
    }

    .content li {
        padding-top: 15px;
    }

    .left-text {
        color: #666666;
        font-size: 14px;
        float: left;
        margin-top: 14px;
        margin-left: 14px;
    }
    .left-text-price {
        color: #FF6347;
        font-size: 16px;
        float: left;
        margin-top: 11px;
        margin-left: 2px;
    }

    .right-text {
        float: right;
        margin: 14px;
    }

    .order-operation {
        height: 45px;
        margin-top: 1px;
        background-color: #ffffff;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    #personalOrders .van-card:not(:first-child) {
        margin-top: 1px;
    }

    .left-button {
        float: right;
        margin: 6px;
    }

    .right-button {
        float: right;
        margin: 6px;
    }

    ::v-deep .van-tabs__wrap {
        position: fixed;
        left: 0;
        right: 0;
        top: 46px;
        z-index: 100;
    }

    ::v-deep .van-tabs__content {
        padding-top: 44px;
    }

    .cancel-order {
        margin-top: 16px;
        text-align: center;
        font-size: 16px;
    }

    .selected-reason {
        padding: 0px 38px;
    }

    .van-checkbox {
        margin-top: 10px;
    }

    ::v-deep .selected-reason .van-checkbox__label {
        color: #666666;
    }

    .cancel-order-button {
        text-align: center;
        color: red;
        font-size: 16px;
        height: 36px;
    }

    ::v-deep .van-list__finished-text {
        float: left;
        width: 100%;
        position: relative;
        left: 0;
    }
    ul .content {
        display: inline-block;
        width: 100%;
    }

</style>
